<template>
  <span :tooltip="tooltipText"><slot /></span>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    tooltipText: {
      type: String,
      default: "Tooltip text",
    },
    position: {
      default: "top",
      type: String,
    },
  },
}
</script>

<style scoped>
[tooltip]:after {
  width: 14em;
  white-space: normal;
}
</style>



